





import { Vue, Component } from 'vue-property-decorator'
import { b64_to_utf8 } from '../../utils/b64utf8';

@Component
export default class extends Vue {
  get message() {
    return b64_to_utf8(this.$route.query.message as string)
  }
}
